import Page from 'components/Page';
import React, {Component} from 'react';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
  CardFooter
} from 'reactstrap';

import Cargando from './../components/Cargando';
import Confirmar from '../components/ModalConfirmar'; 
import { FaSave } from "react-icons/fa";
import Notificaciones from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from 'utils/constants';
import SelectComuna from './../components/SelectComunas'; 
import actualizarse from '../core/useCases/actualizarse';
import Authentication from '../core/frameworks/Authentication';
import u from './../utils/utils'; 


import {validarItem, validarFormulario} from './../utils/validar'; 

import Usuario from './../api/Usuario'; 


const usuario = new Usuario(); 




class ConfiguracionUsuario extends Component {

    constructor() {
        super(); 
        this.state = {
            id:'',
            nombres:'',
            apellidos: '',
            email:'',
            pass:'',
            telefono:'',
            direccion:'',
            comuna:'',
            ocultarActual:true,
            ocultarNueva:true,
            ocultarNueva2:true,
            passNueva:'',
            passNueva2:'',

            validacion: {
                nombres:false,
                apellidos:false,
                email:false,
                direccion:false
            },
            validacionPass:{
                actual:false,
                nueva:false,
                nueva2:false
            },

            confirmarEditarUsuario: false,
            confirmarEditarPass: false,
            cargando:false

        }
    }

    manejaCambio = (e) => {
		const { name, value } = e.target;
		this.setState({ [name]: value });
    }

    manejaComuna = (value) => {
        this.setState({comuna: value});
    
    }

    cargarListado = async (id) => {

        let u = await usuario.mostrar(id); 
        this.setState({
            nombres:u.nombres,
            apellidos: u.apellidos,
            email:u.email,
            direccion:u.direccion,
            comuna:{value: u.comuna, label:u.comuna},
            telefono:u.telefono,
        })
    
    }


    validacionFormulario = async () => {
        const { nombres, apellidos, email, direccion, comuna, telefono} = this.state;  

        let vNombres     = validarItem({valor:nombres, input:'Nombres', vacio:true, texto:true, largo:90});
        let vApellidos   = validarItem({valor:apellidos, input:'Apellidos', vacio:true, texto:true, largo:90});
        let vEmail       = validarItem({valor:email, input:'Email', vacio:true, largo:90, email:true});
        let vDireccion   = validarItem({valor:direccion, input:'Direccion', vacio:true, largo:200});
        let vComuna      = validarItem({valor:comuna, input:'Comuna', vacio:true});
        let vTelefono    = validarItem({valor:telefono, input:'Teléfono', largo:20});

        this.setState({ validacion:{
            nombres:    !vNombres.resultado, 
            apellidos:  !vApellidos.resultado, 
            email:      !vEmail.resultado,
            direccion:  !vDireccion.resultado,
            comuna:     !vComuna.resultado,
            telefono:   !vTelefono.resultado
        } }); 

        let formulario = validarFormulario([vNombres, vApellidos, vEmail, vDireccion, vComuna, vTelefono]); 

        return formulario;
        
    }

    callbackCorrecto = () =>{
        this.Notificaciones.addNotification({
            title: <FaSave/>,
            message: 'Información actualizada correctamente',
            level: 'success',
            position:'tr'
        });
    }

    errorCallback = () =>{
        this.Notificaciones.addNotification({
            message: 'Error inesperado',
            level: 'error',
            position:'tr'
        });

    }

    actualizarUsuarioBD = async () =>{
        this.setState({cargando:true});
        const { id, nombres, apellidos, email, direccion, comuna, telefono} = this.state;  
        let resultado = await usuario.editar( id, '', nombres, apellidos, email, '',  direccion, comuna.value, telefono )
        
        if(resultado==="ok"){
            actualizarse({
                Authentication,
                callbackCorrecto: this.callbackCorrecto,
                errorCallback: this.errorCallback
            });

        } else{
            this.Notificaciones.addNotification({
                message: 'Error inesperado, intentelo más tarde',
                level: 'error',
                position:'tr'
            });  
        }

        this.setState({cargando:false});

    }


    editarUsuario = async () => {

        let formulario = await this.validacionFormulario();

        if(formulario.resultado){
    
            this.muestraConfirmarUsuario();
           
        }else{
            let mensajes = formulario.mensajes; 

            for (const k in mensajes) {

                this.Notificaciones.addNotification({
                    message: mensajes[k],
                    level: 'error',
                    position:'tr'
                });
                 
            }
    
        }  

    }



    ocultarMostrar = valor => () => {   
        this.setState(prevState => {
          const ocultar = prevState[`ocultar${valor}`];
    
          return {
            [`ocultar${valor}`]: !ocultar,
          };
        });
    };
    

    generarPass = () => {
        let pass = u.generarPass(8); 
        this.setState({
            ocultarNueva:false,
            ocultarNueva2:false,
            passNueva:pass,
            passNueva2:pass
        })
        
    }



    validarFormularioPass = () =>{
        const {pass, passNueva, passNueva2} = this.state;

        let vPass          = validarItem({valor:pass, input:'Contraseña actual', vacio:true, largo:45});
        let vPassNueva     = validarItem({valor:passNueva, input:'Contraseña nueva', vacio:true, largo:45});
        let vPassNueva2    = validarItem({valor:passNueva2, input:'Repetir contraseña', vacio:true, largo:45});

        this.setState({ validacionPass:{
            actual:      !vPass.resultado, 
            nueva:       !vPassNueva.resultado, 
            nueva2:      !vPassNueva2.resultado,
        } }); 

        let formulario = validarFormulario([vPass, vPassNueva, vPassNueva2]); 

        return formulario;
    }


    actualizarPassBD = async () =>{
        this.setState({cargando:true});
        let {id, pass, passNueva} = this.state;

        let resultado = await usuario.editarPass(id, pass, passNueva); 
            
        if(resultado==="ok"){
            this.Notificaciones.addNotification({
                title: <FaSave/>,
                message: 'Contraseña actualizada correctamente',
                level: 'success',
                position:'tr'
            });

            this.setState({pass:'', passNueva:'', passNueva2:''})
        } else{
            this.Notificaciones.addNotification({
                message: resultado,
                level: 'error',
                position:'tr'
            });  
        }
        this.setState({cargando:false});
    }


    editarPass = async() => {
        let formulario = await this.validarFormularioPass();

        if(formulario.resultado){

            let {passNueva, passNueva2} = this.state;
            
            if(passNueva===passNueva2){
            
                this.muestraConfirmarPass();

            }else{
                this.Notificaciones.addNotification({
                    message: 'La contraseña nueva es diferente a la contraseña nueva repetida',
                    level: 'error',
                    position:'tr'
                });  
                
            }

  
        }else{
            let mensajes = formulario.mensajes; 

            for (const k in mensajes) {

                this.Notificaciones.addNotification({
                    message: mensajes[k],
                    level: 'error',
                    position:'tr'
                });
                 
            }
    
        }  


  
    }



    
    muestraConfirmarUsuario = () => {
        this.setState(prevState => ({
            confirmarEditarUsuario: !prevState.confirmarEditarUsuario
        }));    
    }

    muestraConfirmarPass = () => {
        this.setState(prevState => ({
            confirmarEditarPass: !prevState.confirmarEditarPass
        }));    
    }



    componentDidMount(){
        this.cargarListado(this.props.user.rut);
        this.setState({id:this.props.user.rut})
    }

    render(){

        const {nombres, apellidos, email, direccion, comuna, telefono,  ocultarActual, ocultarNueva, ocultarNueva2, pass, passNueva, passNueva2, validacion, validacionPass, confirmarEditarUsuario, confirmarEditarPass, cargando} = this.state;  
        return (
            <Page title="Configuración de usuario" breadcrumbs={[ { name: 'Configuración de usuario', active: true } ]}>
                
                <Cargando valor={cargando} />
        
                <Card>
                    <CardHeader>Información</CardHeader>
                    <CardBody>
              
         
                        <Row className="no-margin-bottom">
        
        
                            <Col  lg={3} md={4} sm={12}>
                                <FormGroup>
                                    <Label>Nombres</Label>
                                    <Input
                                        type="text"
                                        name="nombres"
                                        value={nombres}
                                        onChange={this.manejaCambio}
                                        invalid={validacion.nombres}
                                        maxLength={90}
                                    />
                                </FormGroup>
                            </Col>
                            <Col  lg={3} md={4} sm={12}>
                                <FormGroup>
                                    <Label>Apellidos</Label>
                                    <Input
                                        type="text"
                                        name="apellidos"
                                        value={apellidos}
                                        onChange={this.manejaCambio}
                                        invalid={validacion.apellidos}
                                        maxLength={90}
                                    />
                                </FormGroup>
                            </Col>
                            <Col  lg={4} md={4} sm={12}>
                                <FormGroup>
                                    <Label>Email</Label>
                                    <Input
                                        type="text"
                                        name="email"
                                        value={email}
                                        onChange={this.manejaCambio}
                                        invalid={validacion.email}
                                        maxLength={90}
                                    />
                                </FormGroup>
                            </Col>
        
                            <Col  lg={4} md={4} sm={12}>
                                <FormGroup>
                                    <Label>Dirección</Label>
                                    <Input
                                        type="text"
                                        name="direccion"
                                        value={direccion}
                                        onChange={this.manejaCambio}
                                        invalid={validacion.direccion}
                                        maxLength={200}
                                    />
                                </FormGroup>
                            </Col>

                            <Col  lg={3} md={4} sm={12}>
                               <FormGroup>
                                    <Label>Comuna</Label>
                                    <SelectComuna maneja={this.manejaComuna} comuna={comuna} invalid={validacion.comuna}/>
                                </FormGroup>
                            </Col>

                            <Col  lg={2} md={4} sm={12}>
                                <FormGroup>
                                    <Label>Teléfono</Label>
                                    <Input
                                        type="text"
                                        name="telefono"
                                        value={telefono}
                                        onChange={this.manejaCambio}
                                        invalid={validacion.telefono}
                                        maxLength={20}
                                    />
                                </FormGroup>
                            </Col>

        
                        </Row>
  
                    </CardBody>
                    <CardFooter>
                        <Button color="success" size="sm" onClick={this.editarUsuario}>
                          Guardar
                        </Button>
                    </CardFooter>
                </Card>
        
                <br/>
                <Card>
                    <CardHeader>Cambio de contraseña</CardHeader>
                    <CardBody>
                        <Row className="no-margin-bottom">
                            <Col  lg={3} md={4} sm={12}>
                                <FormGroup>
                                    <Label>
                                        Contraseña actual
                                        <Button color="secondary" size="sm"  className="btn-label" onClick={this.ocultarMostrar("Actual")}>
                                            {ocultarActual ? "Mostrar" : "Ocultar"}
                                        </Button>
                                    </Label>
                                    <Input
                                        type={ocultarActual ? "password" : "text"}
                                        name="pass"
                                        value={pass}
                                        onChange={this.manejaCambio}
                                        invalid={validacionPass.actual}
                                        maxLength={45}
                                    />
                                </FormGroup>
                            </Col>
                            <Col  lg={3} md={4} sm={12}>
                                <FormGroup>
                                    <Label>
                                        Contraseña nueva
                                        <Button color="secondary" size="sm"  className="btn-label"  onClick={this.ocultarMostrar("Nueva")}>
                                            {ocultarNueva ? "Mostrar" : "Ocultar"}
                                        </Button>
                                    </Label>
                                    <Input
                                        type={ocultarNueva ? "password" : "text"}
                                        name="passNueva"
                                        value={passNueva}
                                        onChange={this.manejaCambio}
                                        invalid={validacionPass.nueva}
                                        maxLength={45}
                                    />
                                </FormGroup>
                            </Col>
                            <Col  lg={3} md={4} sm={12}>
                                <FormGroup>
                                    <Label>
                                        Repetir contraseña
                                        <Button color="secondary" size="sm"  className="btn-label"  onClick={this.ocultarMostrar("Nueva2")}>
                                            {ocultarNueva2 ? "Mostrar" : "Ocultar"}
                                        </Button>
                                    </Label>
                                    <Input
                                        type={ocultarNueva2 ? "password" : "text"}
                                        name="passNueva2"
                                        value={passNueva2}
                                        onChange={this.manejaCambio}
                                        invalid={validacionPass.nueva2}
                                        maxLength={45}
                                    />
                                </FormGroup>
                            </Col>
                            <Col  lg={3} md={4} sm={12}>
                                <FormGroup>
                                <Button color="primary" size="sm" className="btn-cuerpo" onClick={this.generarPass}>
                                    Generar contraseña
                                </Button>
                                </FormGroup>
                            </Col>
                        </Row>
                    </CardBody>
                    <CardFooter>
                        <Button color="success" size="sm" onClick={this.editarPass}>
                          Guardar
                        </Button>
                    </CardFooter>
                </Card>

                <Notificaciones
                    dismissible={false}
                    ref={Notificaciones =>
                        (this.Notificaciones = Notificaciones)
                    }
                    style={NOTIFICATION_SYSTEM_STYLE}
                    />
        

                <Confirmar 
                    isOpen={confirmarEditarUsuario} 
                    toggle={this.muestraConfirmarUsuario} 
                    texto={"¿Esta seguro de actualizar su información de usuario ?"} 
                    funcion={this.actualizarUsuarioBD} 
                />

                <Confirmar 
                    isOpen={confirmarEditarPass} 
                    toggle={this.muestraConfirmarPass} 
                    texto={"¿Esta seguro de actualizar su contraseña?"} 
                    funcion={this.actualizarPassBD} 
                />
            </Page>
        );
    }
  
};

export default ConfiguracionUsuario;
